export default {
  // {

	daily: [{diamond: "5",marquee:  "9", platinum: "12", gold: "24", silver: "24", bronze: "7"}],
	game_23COMBO: [{diamond: "5", marquee: "6", platinum: "11", gold: "21", silver: "17", bronze: "5"}],
	game_23DPLAY: [{diamond: "0", marquee: "3", platinum: "1", gold: "3", silver: "7", bronze: "2"}],
	half_red: [{diamond: "2", marquee: "7", platinum: "5", gold: "13", silver: "11", bronze: "3"}],
	half_blue: [{diamond: "4", marquee: "2", platinum: "7", gold: "11", silver: "13", bronze: "4"}],



  // },
};
